module.exports = __webpack_public_path__ + "img/qctt.52d2c6c7.jpg";